import React, { Component } from 'react';
import { DatePicker, message, Select, Table, Dropdown, Drawer, Checkbox } from 'antd';
import DataTable from './Datatable';
import moment from 'moment-timezone';
import LogPayment from './LogPayment';
import { map, isEqual } from 'lodash';
import _ from 'lodash';
// import RefundPayment from "./RefundPayment";
import Loader from '../../../Common/Component/Loader';
import { errorHandle } from "../../../Common/errorHandle";
import { formatToCurrency } from "../../../../Tools/formatToCurrency";
import RefundPayment from '../../../ResidentialManagement/CustomerDetail/Component/Common/RefundPayment';

const { Option } = Select;
const { RangePicker } = DatePicker;
const status_mapping = [{key: 'open', value: 'Open'},
  {key: 'open-emailed', value: 'Open-Emailed'},
  {key: 'open-printed', value: 'Open-Printed'},
  {key: 'overdue', value: 'Overdue'},
  {key: 'paid', value: 'Paid'},
  {key: 'void', value: 'Void'},
  {key: 'draft', value: 'Draft'},
];
class AccountListTable extends Component {
  state = {
    accountList: [],
    selectedRowKeys: [],
    customerList: [],
    filteredCustomerList: [],
    franchiseList: [],
    tabData: {},
    account_list_pagination: { current: 1, showSizeChanger: false, pageSize: 15, ordering: "", },
    account_list_filter: {
      billing_type: '',
      status: [],
      invoice_date__lte: '',
      invoice_date__gte: '',
      due_date__lte: '',
      due_date__gte: '',
      user__uuid: '',
      balance_due__lte: '',
      balance_due__gte: ''
    },
    count_filter: {
      invoice_date__lte: '',
      invoice_date__gte: '',
      balance_due__lte: '',
      balance_due__gte: ''
    },
    crr_user: {},
    action_type: '',
    search_value: '',
    active_pagination: '15',
    delete_id: '',
    isNav: '',
    set_table_active_action: '',
    curr_id: '',
    openNav: false,
    loader: false,
    is_log_payment: false,
    delete_visible: false,
    is_change_log_payment: true,
    showRefundPayment: false,
    invoice_date: '',
    is_open_date_picker: false,
    refundTypeValue:null,
    showLogPayment:false,
    customer: {},
    ComCustomer:{},
    cardList:{},
    selectedBatchOption:'',
    all_selected: false,
    all_selected_keys_length: 0
  }

  componentDidMount = () => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const { customerId, getCardList } = this.props;
   
    if (user?.user?.role.includes(`business_dev_franchiese`) || user?.user?.role.includes(`accounting_franchiese`) || user?.user?.role.includes(`operations_mgr`)) {
      this.setState({ is_change_log_payment: false })
    }

    let { account_list_filter } = this.state;

    //Get Acccount Listing
    account_list_filter = Object.assign(account_list_filter, {
      invoice_date__lte: moment().endOf('month').format('YYYY-MM-DD'),
      invoice_date__gte: moment().startOf('month').format('YYYY-MM-DD')
    })
    this.setState({
      account_list_filter
    })
    this.props.getAccountListing({
      limit: 15, 
      offset: 0,
      invoice_date__lte: moment().endOf('month').format('YYYY-MM-DD'),
      invoice_date__gte: moment().startOf('month').format('YYYY-MM-DD')
    });
    //Get Acccount Tab
    this.props.getAccountListingTab({
      invoice_date__lte: moment().endOf('month').format('YYYY-MM-DD'),
      invoice_date__gte: moment().startOf('month').format('YYYY-MM-DD')
    });
    //List of customer
    this.props.getCustomers({ limit: 10, offset: 0 })
    //Get Franchise List
    this.props.getFranchiseList({ limit: 0, offset: 0 });
    // if(customerType==='residential'){
    //   this.props.getCustomerDetail(row?.user_uuid) // get customer detail
    // }else{
    //   this.props.getCommercialCustomer(row?.user_uuid)
    // }
    // this.setState({
    //   loader: true
    // })
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let {
      account_list_pagination,
      active_pagination,
      account_list_filter,
      search_value,
      list,cardList,
      all_selected,
      selectedRowKeys,
      selectedBatchOption
    } = this.state;
    
    if(this.props.selectedBatchOption!==''){
      this.onSelectBatchOption(this.props.selectedBatchOption);
    }

    //get card list
    if (Object.keys(props?.CardList?.data).length > 0 && JSON.stringify(props?.CardList?.data) !== JSON.stringify(cardList)) {
      this.setState({ cardList: props?.CardList?.data, loader: false });
    }

    // Get Account List
    if (Object.keys(props.GetAccountList.data).length > 0 && 
      props.GetAccountList.data !== this.props.GetAccountList.data) {
      
      account_list_pagination.total = props.GetAccountList.data.count;

      this.setState({
        loader: false,
        account_list_pagination,
        set_table_active_action: '',
        accountList: props.GetAccountList.data.results,
      });
    }

    if (Object.keys(props?.GetAccountList?.errors)?.length > 0 && props?.GetAccountList?.errors !== this.props?.GetAccountList?.errors) {
      errorHandle(props.GetAccountList.errors)
      this.setState({
        loader: false,
        set_table_active_action: ''
      })
    }

    // Get all Account uuids
    if(Object.keys(props.GetAllAcountingListUuid.data).length > 0 && 
      props.GetAllAcountingListUuid.data !== this.props.GetAllAcountingListUuid.data)
    {
      let keys=[];
      keys = props?.GetAllAcountingListUuid?.data.results.map(row => {
        return row?.uuid;
      });

      this.setState({
        loader: false,
        selectedRowKeys: keys,
        all_selected_keys_length: keys.length,
      });
    }

    if (Object.keys(props?.GetAllAcountingListUuid?.errors)?.length > 0 && 
      props?.GetAllAcountingListUuid?.errors !== this.props?.GetAllAcountingListUuid?.errors) {
      errorHandle(props.GetAllAcountingListUuid.errors);
      this.setState({
        loader: false,
        set_table_active_action: ''
      })
    }

    // get customer detail
    if (Object.keys(props?.CustomerList?.customer)?.length > 0) { 
      this.setState({ customer: props?.CustomerList?.customer });
    }
    
    // get customer detail
    if (Object.keys(props?.CommercialCustomer?.getCustomer)?.length > 0) { 
      this.setState({ ComCustomer: props?.CommercialCustomer?.getCustomer });
    }

    //Get Tab Data
    if (Object.keys(props?.GetTabData?.data)?.length > 0 && props.GetTabData.data !== this.props?.GetTabData?.data) {
      this.setState({
        tabData: props.GetTabData.data,
        set_table_active_action: ''
      })
    }

    if (Object.keys(props?.GetTabData?.errors)?.length > 0 && props?.GetTabData?.errors !== this.props?.GetTabData?.errors) {
      errorHandle(props.GetTabData.errors)
      this.setState({
        loader: false,
        set_table_active_action: ''
      })
    }

    //Get Customer List
    if (Object.keys(props?.CustomerList?.customerList)?.length > 0 && props?.CustomerList?.customerList !== this.props?.CustomerList?.customerList) {
      this.setState({
        customerList: props.CustomerList.customerList.results,
        filteredCustomerList: props.CustomerList.customerList.results,
        set_table_active_action: ''
      })
    }

    if (Object.keys(props?.CustomerList?.errors)?.length > 0 && props?.CustomerList?.errors !== this.props?.CustomerList?.errors) {
      errorHandle(props.CustomerList.errors)
      this.setState({
        loader: false,
      })
    }

    //get franchise list
    if (Object.keys(props?.FranchiseList?.data)?.length > 0 && props?.FranchiseList?.data !== this.props?.FranchiseList?.data) {
      this.setState({
        franchiseList: props.FranchiseList.data.results,
        loader: false,
        set_table_active_action: ''
      })
    }
    if (Object.keys(props?.FranchiseList?.errors)?.length > 0 && props?.FranchiseList?.errors !== this.props?.FranchiseList?.errors) {
      // display error messsage
      errorHandle(props.FranchiseList.errors)
      this.setState({ loader: false, set_table_active_action: '' })
    }

    //Process Invoice
    if (Object.keys(props?.InvoiceProcess?.data)?.length > 0 && 
      props?.InvoiceProcess?.data !== this.props?.InvoiceProcess?.data) {
      
      message.success(props.InvoiceProcess.data?.message, 10);

      this.setState({
        loader: false,
        selectedRowKeys:[],
        all_selected: false
      });

      let data = {
        offset: 0, 
        limit: 15,
        ...account_list_filter
      }

      data.status = data.status.toString();
      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

      // this.props.getAccountListing(data)
      this.onClearBatchOption();
    }

    //Invoice Email Send
    if (Object.keys(props?.InvoiceEmailSend?.data)?.length > 0 && 
      props?.InvoiceEmailSend?.data !== this.props.InvoiceEmailSend?.data) {
      
      message.success(props?.InvoiceEmailSend.data?.message, 10);

      this.setState({
        loader: false,
        selectedRowKeys:[],
        all_selected:false
      });

      let data = {
        offset: 0, ...account_list_filter
      }

      data.status = data.status.toString();
      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
      // this.props.getAccountListing(data)
      this.onClearBatchOption();
    }


    if (Object.keys(props?.InvoiceProcess?.errors)?.length > 0 && 
      props?.InvoiceProcess?.errors !== this.props?.InvoiceProcess?.errors) {
      // display error messsage

      this.setState({ loader: false});

      if (props.InvoiceProcess?.errors?.detail) {
        message.error(props.InvoiceProcess?.errors?.detail, 10);
      }
      else {
        errorHandle(props.InvoiceProcess?.errors);
      }
    }

    //delete record
    if (Object.keys(props?.DeleteInvoice?.data)?.length > 0 && props?.DeleteInvoice?.data !== this.props?.DeleteInvoice?.data) {
      message.success(props.DeleteInvoice.data?.message, 10);
      this.setState({
        loader: false,
        delete_visible: false,
        delete_id: '',
        set_table_active_action: '',
        selectedRowKeys:[],
        all_selected:false
      });
      let data = {
        offset: (account_list_pagination.current * 15) - 15,
        limit: active_pagination,
        ...account_list_filter,
        search: search_value,
      }
      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
      // this.props.getAccountListing(data)
      this.onClearBatchOption();
    }

    if (Object.keys(props?.DeleteInvoice?.errors)?.length > 0 && props?.DeleteInvoice?.errors !== this.props?.DeleteInvoice?.errors) {
      // display error messsage
      this.setState({ loader: false, set_table_active_action: '',delete_visible: false, delete_id: '', })
      if (props.DeleteInvoice.errors.detail) {
        message.error(props.DeleteInvoice.errors?.detail, 10);
      }
      else {
        errorHandle(props.DeleteInvoice.errors)
      }
    }

    //Resend  Invoice
    if (Object.keys(props.ResendInvoice.data).length > 0 && props.ResendInvoice.data !== this.props.ResendInvoice.data) {
      this.setState({
        loader: false,
        set_table_active_action: ''
      })
      message.success(props?.ResendInvoice?.data?.message, 10);
    }
    if (Object.keys(props?.ResendInvoice?.errors)?.length > 0 && props?.ResendInvoice?.errors !== this.props?.ResendInvoice?.errors) {
      // display error messsage
      this.setState({ loader: false, set_table_active_action: '' })
      if (props?.ResendInvoice?.errors?.message) {
        message.error(props?.ResendInvoice?.errors?.message, 10);
      }
      else {
        errorHandle(props?.ResendInvoice?.errors)
      }
    }

    //Void  Invoice
    if (Object.keys(props?.VoidInvoice?.data)?.length > 0 && props?.VoidInvoice?.data !== this.props?.VoidInvoice?.data) {
      this.setState({
        loader: false,
        set_table_active_action: ''
      });

      let data = {
        offset: (account_list_pagination.current * 15) - 15,
        limit: active_pagination,
        ...account_list_filter,
        search: search_value,
      }
      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
      this.props.getAccountListing(data)
    }

    if (Object.keys(props?.VoidInvoice?.errors)?.length > 0 && props?.VoidInvoice?.errors !== this.props?.VoidInvoice?.errors) {
      // display error messsage
      this.setState({ loader: false, set_table_active_action: '' });

      if (props?.VoidInvoice?.errors?.message) {
        message.error(props?.VoidInvoice?.errors?.message, 10);
      }
      else {
        errorHandle(props?.VoidInvoice?.errors)
      }
    }

    //Log Payment
    if (Object.keys(props?.GetManualy?.data)?.length > 0 && props?.GetManualy?.data !== this.props?.GetManualy?.data) {
      this.setState({
        set_table_active_action: ''
      });
      //Get Acccount Listing
      this.props.getAccountListing({
        ...account_list_filter, offset: (account_list_pagination.current * 15) - 15,
        limit: active_pagination,
        search: search_value
      });
    }

    if (Object.keys(props?.GetManualy?.errors)?.length > 0 && props?.GetManualy?.errors !== this.props?.GetManualy?.errors) {
      errorHandle(props.GetManualy.errors)
      this.setState({
        loader: false,
        set_table_active_action: ''
      });
    }

    //Print Invoice
    if (Object.keys(props?.PrintedInvoice?.data)?.length > 0 && props?.PrintedInvoice?.data !== this.props?.PrintedInvoice?.data) {
      //Print Invoice
      this.setState({
        loader: false,
        selectedRowKeys: [],
        set_table_active_action: ''
      });
      var byteCharacters = atob(props?.PrintedInvoice?.data?.data);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var file = new Blob([byteArray], { type: 'application/pdf;base64' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
    if (Object.keys(props?.PrintedInvoice?.errors)?.length > 0 && props?.PrintedInvoice?.errors !== this.props?.PrintedInvoice?.errors) {
      errorHandle(props.PrintedInvoice.errors)
      this.setState({
        loader: false,
        set_table_active_action: ''
      });
    }

    //Send Reminder
    if (Object.keys(props?.SendInvoiceReminder?.data)?.length > 0 && props?.SendInvoiceReminder?.data !== this.props?.SendInvoiceReminder?.data) {
      //Print Invoice
      this.setState({
        loader: false,
        selectedRowKeys: [],
        set_table_active_action: ''
      });
      message.success(props?.SendInvoiceReminder?.data?.message, 10);
    }

    if (Object.keys(props?.SendInvoiceReminder?.errors)?.length > 0 && props?.SendInvoiceReminder?.errors !== this.props?.SendInvoiceReminder?.errors) {
      errorHandle(props.SendInvoiceReminder.errors)
      this.setState({
        loader: false,
        set_table_active_action: ''
      });
    }

    //batch invoice
    if (Object.keys(props?.BatchInvoice?.data)?.length > 0 && props?.BatchInvoice?.data !== this.props?.BatchInvoice?.data) {
      //Print Invoice
      this.setState({
        loader: false,
      });
      message.success(props?.BatchInvoice?.data?.message, 10);
    }

    if (Object.keys(props?.BatchInvoice?.errors)?.length > 0 && props?.BatchInvoice?.errors !== this.props?.BatchInvoice?.errors) {
      errorHandle(props.BatchInvoice.errors)
      this.setState({
        loader: false,
        set_table_active_action: ''
      });
    }
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'));
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_corporate = logged_in_user_role?.includes('accounting_corporate')
    const is_corporate = logged_in_user_role?.includes('admin')
    const is_account_franchise = logged_in_user_role?.includes('accounting_franchiese')
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);

    return {franchise_uuid, is_franchise_owner, is_account_corporate, is_corporate, is_account_franchise}
  }

  // toggle loader
  toggleLoader = (value) => {
    this.setState({ loader: value })
  };

  //Render DatePicker Footer
  renderDatePickerFooter = () => {
    return (
      <div className="pt-10 pb-10 text-right">
        <button className="btn btn-brand btn-bdr">Cancel</button>
        <button className="btn btn-warning">Apply</button>
      </div>
    )
  }

  renderHeaderCheckbox = () => {
    return <Checkbox 
      disabled={this.state.selectedBatchOption === '' && this.state.selectedRowKeys.length === 0 ? true : false}
      checked={this.state.all_selected}
      onChange={() => this.handleSelectAll()}
    />
  }

  handleSelectAll = () => {
    let {
      all_selected,
      selectedBatchOption,
      account_list_filter,
    } = this.state;

    account_list_filter = Object.assign(account_list_filter);

    if(!all_selected)
    {
      this.setState({
        loader: true,
        all_selected: true,
        selectedRowKeys: []
      });
      
      let data = {
        offset: 0,
        limit: 5000,
        ...account_list_filter
      };

      if(selectedBatchOption !== 'email_invoices')
      {
        data = Object.assign(data, { 'action': 'only_not_proceessed' });
      }
  
      data.status = data.status.toString();
      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

      this.props.getAllAcountingListUuid(data);
    }

    else { 
      this.setState({
        selectedRowKeys:[],
        all_selected: false,
      });
    }

  }

  renderAccountTable = () => {
    const { 
      accountList, 
      selectedRowKeys,
      account_list_pagination,
      active_pagination,
      selectedBatchOption 
    } = this.state;

    return (
      <React.Fragment>
        <Table
          rowKey="uuid"
          dataSource={accountList}
          pagination={account_list_pagination}
          onChange={this.accountPagintaion}
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys,
            preserveSelectedRowKeys: true,
            columnTitle:this.renderHeaderCheckbox,
            onSelectAll:this.handleSelectAll,
            onChange: this.onSelectedRowKeysChange,
            getCheckboxProps: (record) => {
              return {
                disabled: selectedBatchOption === '' || (selectedBatchOption !== "email_invoices" && record?.is_proceessed ? true : false),
              }
            },
          }}
          columns={DataTable.AllAccountList(this)} />

        {accountList?.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setMessagePageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </React.Fragment>
    )
  }

  //Account PAgination
  accountPagintaion = (pagination, filter_filler, sorter) => {
    let { 
      account_list_pagination,
      active_pagination,
      search_value,
      account_list_filter,
    } = this.state;

    let ordering = '';
    
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }

    account_list_pagination = Object.assign(account_list_pagination, { 'current': pagination.current,'ordering':ordering });

    this.setState({
      account_list_pagination,
      loader: true
    });

    let data = {
      ordering,
      offset: (pagination.current * active_pagination) - active_pagination,
      limit: active_pagination,
      ...account_list_filter,
      ...account_list_pagination,
      search: search_value,
    }

    data.status = data.status.toString();
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAccountListing(data);
  }

  //Selct Table Row checkbox
  onSelectedRowKeysChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }

  //set page limit
  setMessagePageLimit = (custom_limit, sorter) => {
    let { 
      search_value, 
      account_list_pagination,
      account_list_filter 
    } = this.state;

    account_list_pagination = Object.assign(account_list_pagination, { 'current': 1, 'pageSize': custom_limit });

    this.setState({
      account_list_pagination,
      loader: true,
      active_pagination: custom_limit,
      // search_value:''
    })

    let data = {
      offset: 0,
      limit: custom_limit,
      search: search_value,
      ...account_list_filter,
      ...account_list_pagination
    };

    data.status = data.status.toString();
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAccountListing(data);
  }

  // Show Table Nav
  ShowNav = (record,) => {
    if (!this.state.openNav) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      openNav: !prevState.openNav,
      isNav: record.uuid
    }));
  }

  // hide list toggle button
  handleOutsideClick = (e) => {
    // ignore clicks on the Component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.ShowNav({ 'uuid': '' }, '');
  }

  //Date Range Change
  onInvoiceDateRange = (e) => {
    let { account_list_filter, active_pagination, count_filter } = this.state;

    if (e) {
      account_list_filter = Object.assign(account_list_filter, {
        invoice_date__lte: moment(e[1]).format('YYYY-MM-DD'),
        invoice_date__gte: moment(e[0]).format('YYYY-MM-DD'),
      })

      count_filter = Object.assign(count_filter, {
        invoice_date__lte: moment(e[1]).format('YYYY-MM-DD'),
        invoice_date__gte: moment(e[0]).format('YYYY-MM-DD'),
      })
    }
    else {
      account_list_filter = Object.assign(account_list_filter, {
        invoice_date__lte: '',
        invoice_date__gte: '',
      })
      count_filter = Object.assign(count_filter, {
        invoice_date__lte: '',
        invoice_date__gte: '',
      })
    }
    this.setState({
      account_list_filter,
      count_filter
    });
    let data = {
      offset: 0,
      limit: active_pagination,
      ...account_list_filter,
      selectedRowKeys: [],
      all_selected: false,
    }
    let temp_data = {...count_filter}

    data.status = data.status.toString();
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    Object.keys(temp_data).forEach((key) => (temp_data[key] === null || temp_data[key] === '') && delete temp_data[key]);

    this.setState({loader: true});
    this.props.getAccountListing(data);
    this.props.getAccountListingTab(temp_data);
  }

  //Due Date Range
  onDueDateRange = (e) => {
    let { account_list_filter, active_pagination, count_filter } = this.state;

    if (e) {
      account_list_filter = Object.assign(account_list_filter, {
        due_date__lte: moment(e[1]).format('YYYY-MM-DD'),
        due_date__gte: moment(e[0]).format('YYYY-MM-DD'),
      })
      count_filter = Object.assign(count_filter, {
        due_date__lte: moment(e[1]).format('YYYY-MM-DD'),
        due_date__gte: moment(e[0]).format('YYYY-MM-DD'),
      })
    }
    else {
      account_list_filter = Object.assign(account_list_filter, {
        due_date__lte: '',
        due_date__gte: '',
      })
      count_filter = Object.assign(count_filter, {
        due_date__lte: '',
        due_date__gte: '',
      })
    }

    this.setState({
      account_list_filter,
      count_filter
    });

    let data = {
      offset: 0,
      limit: active_pagination,
      selectedRowKeys: [],
      all_selected: false,
      ...account_list_filter
    }

    let temp_data = {...count_filter}

    data.status = data.status.toString();
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    Object.keys(temp_data).forEach((key) => (temp_data[key] === null || temp_data[key] === '') && delete temp_data[key]);
    this.setState({loader: true});

    //Call API
    this.props.getAccountListing(data)
    this.props.getAccountListingTab(temp_data);
  }

  //Table Inner Filter
  TypeChange = (type, value) => {
    let { account_list_filter, active_pagination } = this.state;

    account_list_filter = Object.assign(account_list_filter, { [type]: value });
    this.setState({
      account_list_filter,
      loader: true
    });

    let data = {
      offset: 0,
      limit: active_pagination,
      selectedRowKeys: [],
      all_selected: false,
      ...account_list_filter
    }

    data.status = data.status.toString();
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    //Call API
    this.props.getAccountListing(data)

  }

  //inner Status Change
  StatusChange = (type, value) => {
    let { account_list_filter, active_pagination } = this.state;
    let temp_value = account_list_filter.status;

    if (temp_value.length > 0) {
      temp_value[0] = value;
    }
    else {
      temp_value.push(value)
    }

    account_list_filter = Object.assign(account_list_filter, { [type]: temp_value });
    this.setState({
      selectedRowKeys: [],
      all_selected: false,
      account_list_filter,
      loader: true
    });

    let data = {
      offset: 0,
      limit: active_pagination,
      ...account_list_filter
    }

    data.status = data.status.toString();
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    //Call API
    this.props.getAccountListing(data)
  }

  //Customer and Status Change
  customerAndStatusOnChange = (e, type) => {
    const {search_value} = this.state;
    const temp = this.state.filteredCustomerList.filter(item => item.field_office !== null && item.field_office.uuid === e);
    this.setState({ customerList: temp });

    let { account_list_filter, active_pagination } = this.state;

    if (type === 'status' && e[e.length - 1] === '') {
      account_list_filter = Object.assign(account_list_filter, { [type]: [''] });
    } else {
      account_list_filter = Object.assign(account_list_filter, { [type]: e });

      if (type === 'status') {
        const idx = account_list_filter?.status?.indexOf('');

        if (idx > -1) {
          account_list_filter.status.splice(idx, 1);
          account_list_filter = Object.assign(account_list_filter, { status: account_list_filter.status });
        }
      }
    }

    const status = [];
    map(status_mapping, x => status.push(x.key));

    if (isEqual(account_list_filter?.status, status)) {
      account_list_filter = Object.assign(account_list_filter, { [type]: [''] });
    }

    this.setState({
      selectedRowKeys: [],
      all_selected: false,
      account_list_filter,
      loader: true
    });

    let data = {
      offset: 0,
      serch: search_value,
      limit: active_pagination, 
      ...account_list_filter
    }

    data.status = data.status.toString();
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    
    //Call API
    this.props.getAccountListing(data)
  }

  // Search Ticket
  searchAccount = (e) => {
    const { account_list_filter } = this.state;
    this.setState({search_value: e.target.value});

    if (e.target.value?.length >= 3 || e.target.value?.length === 0) {
      const data = {
        offset: 0,
        limit: 15, 
        ...account_list_filter,
        invoice_date__lte: moment(account_list_filter?.invoice_date__lte).endOf('month').format('YYYY-MM-DD'),
        invoice_date__gte: moment(account_list_filter?.invoice_date__gte).startOf('month').format('YYYY-MM-DD')
      };

      data.search = e.target.value;
      data.status = data.status.toString();

      this.props.getAccountListing(data);
    }
  }

  //Log payment Drawer Toggle
  logPaymentToggle = (e) => {
    this.setState({ is_log_payment: e })
  }

  //Clear Text key
  clearKey = () => {
    this.setState({
      set_table_active_action: ''
    })
  }

  //Delete invoice
  deleteAccountInvoice = () => {
    let { delete_id,selectedRowKeys } = this.state;
    let arr = selectedRowKeys
    if(delete_id!==''){
      arr.push(delete_id);
    }
    delete_id = _.uniqBy(arr);
    if (delete_id) {
      this.setState({
        loader: true
      })
      this.props.deleteAccountInvoice({multiple_invoices_uuid:delete_id.join()})
    }
  }

    //Invoice Process
    invoiceProcessEmail = () => {
      let { selectedRowKeys } = this.state;
      this.props.invoiceProcess({multiple_invoices_uuid:selectedRowKeys.join()})
    }

  //Invoice Email
  invoiceEmail = () => {
    let { selectedRowKeys } = this.state;
    this.props.invoiceEmailSend(selectedRowKeys)
  }

  // open date picker
  openInvoiceCalendar = () => {
    this.setState({ is_open_date_picker: true });
  }

  //clear refundTypeValue
  clearRefundTypeValue = (value)=>{
    this.setState({
      refundTypeValue:null
    })
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // on invoice detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    const invoice_date = value ? this.UTCToLocal(value).format('YYYY-MM-DD') : null;
    this.setState({ [e.target.name]: value, loader: true, is_open_date_picker: false });
    const { franchise_uuid } = this.getLoggedInUserRole();
    this.props.batchInvoice({ field_office_uuids: franchise_uuid?.join(','), invoice_date: invoice_date });
  }

    // toggle log payment drawer
    toggleLog = (value) => {
      this.setState({ showLogPayment: value });
    };

    // toggle loader
  // toggleLoader = (value) => {
  //   this.setState({ loader: value })
  // };

  onSelectBatchOption = (value) => {
    this.setState({
      selectedBatchOption: value,
      selectedRowKeys: [],
      all_selected: false,
      loader:true
    });

    this.props.selectedBatch('');

    if(value === 'process_payments_and_email_invoices' || value==='bulk_delete'){
      this.customerAndStatusOnChange(['draft'], 'status');
    }
    if(value === 'print_invoices'){
      this.customerAndStatusOnChange([''], 'status');
    }
    if(value === 'email_invoices'){
      this.customerAndStatusOnChange(['open','open-emailed','open-printed','overdue'], 'status');
    }
    if(value===''){
      this.customerAndStatusOnChange([''], 'status');
    }
  }

  onGoBatchOption = () => {
    this.setState({loader:true});

    if(this.state.selectedBatchOption ==='bulk_delete'){
      this.deleteAccountInvoice()
    }
    if(this.state.selectedBatchOption ==='process_payments_and_email_invoices'){
      this.invoiceProcessEmail()
    }
    if(this.state.selectedBatchOption ==='email_invoices'){
      this.invoiceEmail()
    }
    if(this.state.selectedBatchOption ==='print_invoices'){
      this.props.printInvoice({multiple_invoices_uuid:this.state.selectedRowKeys.join()})
      this.setState({
        selectedRowKeys:[],
        all_selected:false
      })
      this.onClearBatchOption()
    }
  }

  onClearBatchOption = () => {
    this.setState({
      selectedBatchOption:'',
      selectedRowKeys:[],
      all_selected:false,
      loader:true
    })
    this.props.selectedBatch('');
    this.customerAndStatusOnChange([''], 'status');
  }

  onClearFilter = () => {
    this.setState({
      loader:true,
      selectedBatchOption:'',
      selectedRowKeys: [],
      all_selected: false,
      account_list_filter: {
        billing_type: '',
        status: [''],
        invoice_date__lte: '',
        invoice_date__gte: '',
        due_date__lte: '',
        due_date__gte: '',
        user__uuid: '',
        balance_due__lte: '',
        balance_due__gte: '',
        service_order__service_type:''
      }
    })
    let data = {
      offset: 0, limit: this.state.active_pagination, account_list_filter: {
        billing_type: '',
        status: [''],
        invoice_date__lte: '',
        invoice_date__gte: '',
        due_date__lte: '',
        due_date__gte: '',
        user__uuid: '',
        balance_due__lte: '',
        balance_due__gte: ''
      }
    }
  
    this.props.getAccountListing(data)
  }

  render() {
    const {
      selectedRowKeys,
      loader,
      tabData,
      active_pagination,
      customerList,
      search_value,
      franchiseList,
      is_log_payment,
      crr_user,
      showRefundPayment,
      invoice_date,
      is_open_date_picker,
      list,
      showLogPayment,
      selectedBatchOption 
    } = this.state;

    let {
      account_list_filter,
    } = this.state;

    const {
      is_franchise_owner,
      is_account_corporate,
      is_corporate,
      is_account_franchise
    } = this.getLoggedInUserRole();

    const menu = (
      <React.Fragment>
        {!is_open_date_picker && 
          <div className="table_inner_filter_select">
            <ul>
              <li onClick={() => {
                if (selectedRowKeys.length > 0) {
                  this.setState({ loader: true });
                  this.props.printInvoice({ multiple_invoices_uuid: selectedRowKeys.join(','), user_uuid: crr_user?.user?.uuid })
                }
              }}>Print Invoices</li>
              <li onClick={() => {
                if (selectedRowKeys.length > 0) {
                  let selectedId = this.state.accountList.filter(item => selectedRowKeys.indexOf(item.uuid) > -1).map(item => item.uuid)
                  this.setState({ loader: true });
                  this.props.sendInvoiceReminder({ multiple_invoices_uuid: selectedId.join(',') })
                }
              }}>Send Reminders</li>
              {/* {(is_franchise_owner || is_account_corporate || is_corporate || is_account_franchise) ? <li onClick={() => {
                this.setState({ loader: true });
                this.props.batchInvoice({ field_office_uuids: franchise_uuid?.join(',') })
              }}>Batch Invoice</li> : ''} */}

              {(is_franchise_owner || is_account_corporate || is_corporate || is_account_franchise) ? <li onClick={() => {
                this.openInvoiceCalendar()
              }}>Batch Invoice</li> : ''}
            </ul>
          </div>
        }
        {is_open_date_picker && 
          <div className="invoice-container">
            <div className="flex-1">
              <div className="form-group">
                <div className="fitem">
                  <div className="fitem">
                    <label><b>Invoice Date</b></label>
                    <DatePicker
                      inputReadOnly
                      style={{ 'width': '100%' }}
                      // disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                      name='date'
                      format="MM/DD/YYYY"
                      allowClear={false}
                      value={invoice_date ? this.UTCToLocal(invoice_date) : null}
                      onChange={(e) => this.onTextChange({ target: { name: 'invoice_date', value: e } })}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </React.Fragment>
    )
    return (
      <div>
        <div className="filter_wrapper flex full_date_range_picker">
          <div className="form-group flex ai-center fltr-txt">
            <div className="fitem">
              <RangePicker
                format={'MM/DD/YYYY'}
                className="date_ranger dwhite"
                dropdownClassName="dropdown_date_range"
                suffixIcon={<i className="las la-angle-down"></i>}
                onChange={(e) => { this.onInvoiceDateRange(e) }}
                value={account_list_filter.invoice_date__gte && account_list_filter.invoice_date__lte ? [moment(account_list_filter.invoice_date__gte) ? moment(account_list_filter.invoice_date__gte) : undefined, moment(account_list_filter.invoice_date__lte) ? moment(account_list_filter.invoice_date__lte) : undefined] : [null, null]}
                inputReadOnly
              // renderExtraFooter={() => this.renderDatePickerFooter()}
              />
            </div>
            <div className="fitem">

              <RangePicker
                format={'MM/DD/YYYY'}
                className="due_ranger dwhite"
                dropdownClassName="dropdown_date_range"
                suffixIcon={<i className="las la-angle-down"></i>}
                onChange={(e) => { this.onDueDateRange(e) }}
                value={account_list_filter.due_date__gte && account_list_filter.due_date__lte ? [moment(account_list_filter.due_date__gte) ? moment(account_list_filter.due_date__gte) : undefined, moment(account_list_filter.due_date__lte) ? moment(account_list_filter.due_date__lte) : undefined] : [null, null]}
                // renderExtraFooter={() => this.renderDatePickerFooter()}
                inputReadOnly
              />
            </div>
            <div className="fitem">
              <Select
                className="bill_type swhite filter_type"
                defaultValue=""
                value={account_list_filter.billing_type}
                onChange={(e) => {
                  account_list_filter = Object.assign(account_list_filter, { billing_type: e });
                  this.setState({
                    account_list_filter,
                    loader: true
                  })

                  let data = {
                    offset: 0, limit: active_pagination, ...account_list_filter
                  }
                  data.status = data.status.toString();
                  Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
                  //Call API
                  this.props.getAccountListing(data)
                }}
                suffixIcon={<i className="las la-angle-down"></i>}
              >
                <Option value="">All</Option>
                <Option value="email">Email</Option>
                <Option value="print">Print</Option>
              </Select>
            </div>
            <div className="fitem">
              <Select
                style={{ 'width': '150px' }}
                className="status_type swhite filter_type"
                defaultValue=""
                mode="multiple"
                value={account_list_filter.status}
                onChange={(e) => {
                  this.customerAndStatusOnChange(e, 'status')
                }}
                suffixIcon={<i className="las la-angle-down"></i>}
              >
                <Option 
                  value=""
                  disabled={this.state.selectedBatchOption==='bulk_delete' || this.state.selectedBatchOption==='process_payments_and_email_invoices' || this.state.selectedBatchOption==='email_invoices' ? "disabled" : "" }
                  >All</Option>
                {
                  map(status_mapping, x => 
                    <Option 
                      disabled={((this.state.selectedBatchOption==='bulk_delete' || this.state.selectedBatchOption==='process_payments_and_email_invoices') && x?.key !== 'draft' ) || (this.state.selectedBatchOption==='email_invoices' && (x?.key === 'draft' || x?.key === 'paid' || x?.key === 'void')) ? "disabled" : ""}
                      value={x?.key}
                      key={x?.key}
                    >{x?.value}</Option>)}
              </Select>
            </div>
            <div className="fitem">
              <Select
                className="customer_type swhite filter_type"
                defaultValue=""
                value={account_list_filter.service_order__service_type}
                onChange={(e) => {
                  account_list_filter = Object.assign(account_list_filter, { service_order__service_type: e });
                  this.setState({
                    account_list_filter,
                    loader: true
                  })


                  let data = {
                    offset: 0, limit: active_pagination, ...account_list_filter
                  }
                  data.status = data.status.toString();
                  Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
                  //Call API
                  this.props.getAccountListing(data)
                }}
                suffixIcon={<i className="las la-angle-down"></i>}
              >
                <Option value="">All</Option>
                <Option value="residential">Residential</Option>
                <Option value="commercial">Commercial</Option>
              </Select>
            </div>
            {/* <div className="fitem">
              <Select
                showSearch
                showArrow={false}
                filterOption={false}
                className="single_customer swhite filter_type"
                defaultValue=""

                suffixIcon={<i className="las la-search"></i>}
                onChange={(e) => {
                  this.customerAndStatusOnChange(e, 'user__uuid');
                }}
                onSearch={(e) => {
                  this.props.getCustomers({ q: e })
                }}
                onBlur={() => {
                  this.props.getCustomers({ limit: 10, offset: 0 })
                }}
              >
                <Option value="">All</Option>
                {map(customerList, (item) => {
                  return (
                    <Option key={item.uuid}>{item.first_name} {item.last_name}</Option>
                  )
                })}

              </Select>
            </div> */}
          </div>
        </div>
        <div className="filter_wrapper acc-wrap flex">
          <div className="right_side">
            <a onClick={this.onClearFilter}>Clear all Filter</a>
          </div>
        </div>
        <div className="block-row">
          <div className="status-blocks">
            <div className="overdue stcell">
              <div className="flex flex-start ai-center">
                <h2>{tabData?.overdue_invoices_count ? tabData?.overdue_invoices_count : 0}</h2>
                <h4>{tabData?.overdue_invoices_amount?.total_with_tax__sum ? `$${formatToCurrency(tabData?.overdue_invoices_amount?.total__sum)}` : ''}</h4>
              </div>
              <p>OVERDUE</p>
            </div>
            <div className="open stcell">
              <div className="flex flex-start ai-center">
                <h2>{tabData?.open_invoices_count ? tabData?.open_invoices_count : 0}</h2>
                <h4>{tabData?.open_invoices_amount?.total__sum ? `$${formatToCurrency(tabData?.open_invoices_amount?.total__sum)}` : ''}</h4>
              </div>
              <p>OPEN INVOICES</p>
            </div>
            <div className="paid stcell">
              <div className="flex flex-start ai-center">
                <h2>{tabData?.paid_last_30_days_count ? tabData?.paid_last_30_days_count : 0}</h2>
                <h4>{tabData?.paid_last_30_days_amount?.total_with_tax__sum ? `$${formatToCurrency(tabData?.paid_last_30_days_amount?.total_with_tax__sum)}` : ''}</h4>
              </div>
              <p>PAID LAST 30 DAYS</p>
            </div>
          </div>
        </div>
        <div className="block-row">
          <div className="filter_wrapper filter_wrapper_account_list acc-wrap flex">
            <div className="left_side">
              <div className="fitem frachise_border mr-2">   
                <Select
                  className="swhite"
                  showSearch
                  showArrow={true}
                  suffixIcon={<i className="las la-angle-down"></i>}
                  value={selectedBatchOption}
                  onChange={(e) => {
                    this.onSelectBatchOption(e);
                  }}
                >
                  <Option value="">Select-a-Batch Action</Option>
                  <Option value="process_payments_and_email_invoices">Process Payments and Email invoices</Option>
                  <Option value="bulk_delete">Bulk Delete</Option>
                  <Option value="print_invoices">Print Invoices</Option>
                  <Option value="email_invoices">Email Invoices</Option>
                </Select>
              </div>
              {/* <Dropdown overlay={menu} trigger='click'>
                <button className="btn btn-warning" >Batch Actions <i className="las la-angle-down"></i></button>
              </Dropdown> */}
              <a className={selectedBatchOption===''?"btn-disabled disbale_btn mr-2":"btn-warning mr-2"} style={{'marginTop':'10px','color':'green !important','textDecoration':'underline'}} onClick={this.onClearBatchOption} >Refresh</a>
              <button className={this.state.selectedRowKeys.length>0?"btn btn-warning":"btn btn-disabled disbale_btn"} onClick={this.onGoBatchOption} >GO</button>
            </div>
            <div className="right_side" style={{'marginRight':'100px'}}>
              <div className="form-group flex ai-center w-100 flex-end">
                <div className="fitem frachise_border" style={{'width':'160px'}}>   
                  <Select
                    className="swhite franchise_filter"
                    showSearch
                    showArrow={true}
                    suffixIcon={<i className="las la-angle-down"></i>}
                    defaultValue=""
                    disabled={this.props?.is_disable_franchise ? true : false}
                    onSearch={(e) => { this.props.getFranchiseList({ search: e }) }}
                    onBlur={() => { this.props.getFranchiseList({ limit: 0, offset: 0 }) }}
                    onChange={(e) => {
                      this.customerAndStatusOnChange(e, 'field_office__uuid');
                    }}
                  >
                    <Option value="">All</Option>
                    {map(franchiseList, (item) => {
                      return (
                        <Option key={item.uuid}>{item.name}</Option>
                      )
                    })}
                  </Select>
                </div>
                <div className="fitem fitem-rinner licon search_box">
                  <div className="fitem-ricon">
                    <i className="las la-search"></i>
                  </div>
                  <input
                    style={{'width':'345px'}}
                    type="text"
                    placeholder="Invoice Number, Customer Name"
                    value={search_value}
                    onChange={(e) => {
                      this.searchAccount(e)
                    }}
                    onKeyPress={event => {
                      if (event.key === 'Enter') {
                        this.searchAccount({ target: { value: this.state.search_value } })
                      }
                    }}
                    className="form-control flex-1" />
                </div>
              </div>
            </div>
          </div>
          {this.renderAccountTable()}
        </div>
        {loader ? <Loader /> : ''}

        <Drawer
          visible={is_log_payment}
          width={'420'}
          closable={false}
          className="drawer-wrapper create_ticket_drawer"
        >
          <LogPayment
            logPaymentToggle={this.logPaymentToggle}
            clearKey={this.clearKey}
            {...this.props}
            crr_user={crr_user}
            invoice_uuid={crr_user?.uuid}
            customerList={customerList}
            customer={this.state.customer}
            getCommercialCustomer={this.props.getCommercialCustomer}
            getCustomerDetail={this.props.getCustomerDetail}
            CustomerList={this.props.CustomerList}
            CommercialCustomer={this.props.CommercialCustomer}
          />
        </Drawer>
        {
          showRefundPayment && <RefundPayment
            invoice_uuid={crr_user}
            invoice_id={crr_user?.invoice_id}
            customerId={crr_user?.user?.uuid}
            visible={showRefundPayment}
            closeDrawer={() => this.setState({showRefundPayment: false})}
            toggleLoader={this.toggleLoader}
            clearKey={this.clearKey}
            clearRefund ={this.clearRefundTypeValue}
            cardList={this.state.cardList}

            // Api
            // getInvoiceList={() => {
            //   this.props.getAccountListing({
            //     limit: 15, offset: 0,
            //     invoice_date__lte: moment(account_list_filter?.invoice_date__lte).endOf('month').format('YYYY-MM-DD'),
            //     invoice_date__gte: moment(account_list_filter?.invoice_date__gte).startOf('month').format('YYYY-MM-DD')
            //   });
            // }}
            getInvoiceList={this.props.getInvoiceList}
            getInvoiceCreditMemoList={this.props.getInvoiceCreditMemoList}
            getStaffUsers={this.props.getStaffUsers}
            refundPayment={this.props.refundPaymentAccounting}
            getInvoiceById={this.props.getInvoiceById}
            getInvoiceSummary={this.props.getInvoiceSummary}
            actionValue={this.state.actionValue}
            refundTypeValue={this.state.refundTypeValue}
            remainingCreditBalance={this.props.remainingCreditBalance}

            // Reducer
            RefundPayment={this.props.RefundPayment}
            Invoice={this.props.Invoice}
            actionIssueRefund={this.state.actionIssueRefund}
            InvoiceDescription={this.props.InvoiceDescription}
            RemainingCreditBalance={this.props.RemainingCreditBalance}
          />
        }      </div>
    );
  }
}

export default AccountListTable;